import { render, staticRenderFns } from "./main-request-inquiry.vue?vue&type=template&id=18b4346c&scoped=true&"
import script from "./main-request-inquiry.vue?vue&type=script&lang=js&"
export * from "./main-request-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./main-request-inquiry.vue?vue&type=style&index=0&id=18b4346c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b4346c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
